// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"wY","iconEffect":"wZ","ripple":"w0","a":"w1"};